import {
  HamburgerIcon,
  EjectTipIcon,
} from '../../../Icons';

export function useMicroPipetteTooltip() {
  function getButtonList(props) {
    const buttonList = [];

    buttonList.push(
      {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClick: () => {},
        image: HamburgerIcon,
      },
      {
        onClick: props.openVolumeModal,
        label: props.volume + ' uL',
      }
    );

    if (props.onRemoveTip) {
      buttonList.push({
        onClick: props.onRemoveTip,
        image: EjectTipIcon,
      });
    }

    return buttonList;
  }

  return {getButtonList};
}
